import { History } from "history";
import * as React from "react";
import { match } from "react-router-dom";
import { connect } from "react-redux";
import { GlobalState } from "../../store/rootReducer";
import { WotdFormData } from "../../../beans/api";
import { Dispatch } from "redux";
import {
  wotdPresetRequest,
  IWotdPresetRequest,
} from "../../store/WotdPreset/actions";
import { Wrap } from "./styles";
import Heading from "../../components/Heading";
import Content from "../../components/Content";
import InputMail from "../../components/InputMail";
import WotdSelection from "../../components/WotdSelection";
import WotdPrivacy from "../../components/WotdPrivacy";
import { ZButton } from "@zanichelli/albe-web-components/react";
import { ButtonVariant } from "@zanichelli/albe-web-components";
import {
  IWotdFormDataManage,
  IWotdFormDataSet,
  wotdFormDataSet,
  wotdFormDataManage,
} from "../../store/WotdFormData/actions";
import { checkPersonalDataValidation } from "../../../utils/tools";

import i18next from "i18next";
import { withTranslation, WithTranslation } from "react-i18next";
import ZLoader from "../../components/ZLoader";

type Props = {
  match?: match<any>;
  history: History;
  words: WotdFormData["words"];
  personalData: WotdFormData["personalData"];
  wotdFormDataSet: (
    wotdFormData: WotdFormData["words"] | WotdFormData["personalData"],
  ) => IWotdFormDataSet;
  email?: string;
  error: Error | null;
  loading: boolean;
  wotdPresetRequest: (hash: string) => IWotdPresetRequest;
  wotdFormDataManage: (hash?: string) => IWotdFormDataManage;
} & WithTranslation;

type State = {};

class Manage extends React.Component<Props, State> {
  public readonly state: State = {};

  componentDidMount() {
    const { wotdPresetRequest } = this.props;
    const { hash } = this.props?.match?.params;
    wotdPresetRequest(hash);
  }

  checkFormValidity() {
    const { personalData } = this.props;
    return !checkPersonalDataValidation(personalData);
  }

  render() {
    const {
      words,
      personalData,
      email,
      wotdFormDataSet,
      wotdFormDataManage,
      loading,
      history,
    } = this.props;
    const { hash } = this.props.match?.params;

    if (loading) return <ZLoader />;

    return (
      <Wrap>
        <div className="container">
          <Heading
            title={i18next.t("newwotd.title")}
            subtitle={i18next.t("newwotd.home.subtitle")}
          />
          <Content>{i18next.t("newwotd.home.description")}</Content>
          <InputMail
            history={history}
            email={email}
            readonly={true}
            hiddenBtn={true}
            hiddenText={true}
          />
        </div>
        <div className="borders">
          <div className="container">
            <WotdSelection
              handleCheckboxes={wotdFormDataSet}
              checkboxes={words}
            />
          </div>
        </div>
        <div className="container">
          <WotdPrivacy
            handleCheckboxes={wotdFormDataSet}
            checkboxes={personalData}
          />
          <ZButton
            variant={ButtonVariant.PRIMARY}
            disabled={this.checkFormValidity()}
            onClick={() => wotdFormDataManage(hash)}
          >
            {i18next.t("newwotd.checkboxes.button.save")}
          </ZButton>
        </div>
      </Wrap>
    );
  }
}

function mapStateToProps(state: GlobalState) {
  const words =
    state.wotdformdata.wotdFormData && state.wotdformdata.wotdFormData.words;
  const personalData =
    state.wotdformdata.wotdFormData &&
    state.wotdformdata.wotdFormData.personalData;
  const email = state.subscriptionemail && state.subscriptionemail.email;
  const error = state.wotdformdata.error;
  const loading = state.wotdpreset.loading || state.wotdformdata.loading;
  return { words, personalData, email, error, loading };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    wotdPresetRequest: (hash: string) => dispatch(wotdPresetRequest(hash)),
    wotdFormDataSet: (
      checkboxes: WotdFormData["words"] | WotdFormData["personalData"],
    ) => dispatch(wotdFormDataSet(checkboxes)),
    wotdFormDataManage: (hash?: string) => dispatch(wotdFormDataManage(hash)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(Manage));
